<template>
    <div class="page" v-loading="loading">
        <el-breadcrumb>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>提现明细</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" class="top">
            <!-- <el-form-item>
				<el-input v-model="keyword" placeholder="开户名称/手机号/银行卡" size="mini" style="width: 300px;">
				</el-input>
			</el-form-item> -->
            <el-form-item>
                <el-date-picker v-model="date" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
                    size="mini">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" size="mini">刷新</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true">
            <el-form-item>
                <div class="wallet-index">
                    <p>预估佣金（元）</p>
                    <p>{{ estimate }}</p>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="wallet-index">
                    <p>总余额（元）</p>
                    <p>{{ balance }}</p>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="wallet-index">
                    <p>审核中佣金（元）</p>
                    <p>{{ balance_unavailable }}</p>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="wallet-index">
                    <p>可用余额（元）</p>
                    <p>{{ balance_available }}</p>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="withdrawal">
                    <el-button type="danger" size="mini" class="withdrawbtn" @click="toWithdraw">我要提现
                    </el-button>
                </div>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" :header-cell-style="{background:'#F5F5F5'}" size="mini"
            style="width: 100%; margin-bottom: 20px;" stripe border>
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="amount" label="提现金额"></el-table-column>
            <el-table-column prop="ext" label="开户行姓名">
                <template slot-scope="scope">
                    {{ scope.row.ext.card_name }}
                </template>
            </el-table-column>
            <el-table-column prop="ext" label="银行卡预留手机号">
                <template slot-scope="scope">
                    {{ scope.row.ext.card_phone}}
                </template>
            </el-table-column>
            <el-table-column label="提现方式">
                <template>
                    <p>银行卡</p>
                    <span>{{ bankInfo.card_bank.name ? bankInfo.card_bank.name : '' }}: </span>
                    <span>{{ bankInfo.card_num ? bankInfo.card_num : '' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="提现时间"></el-table-column>
            <el-table-column prop="action" label="状态">
                <template slot-scope="scope">
                    <p
                        :class="scope.row.action == 5 ? 'info' : scope.row.action == 6 ? 'success' : scope.row.action == 7 ? 'error' : '' ">
                        {{ scope.row.action == 5 ? '待审核' : scope.row.action == 6 ? '审核通过' : scope.row.action == 7 ?
                        '审核不通过' : '' }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>

        <el-pagination background layout="prev,pager,next,total" :page-count="maxpage" :total="total" :page-size="15"
            @current-change="pageChange"></el-pagination>

        <el-dialog title="提现管理" :visible.sync="infoShow" width="25%" @close="resetInfo" :close-on-click-modal="false">
            <el-form :model="info" ref="info" label-width="130px" :inline="false" size="small" class="wrap">
                <el-form-item label="提现金额" prop="money">
                    <el-input v-model="info.money" style="width: 120px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button size="mini" @click="infoShow=false">取消</el-button>
                <el-button size="mini" type="primary" @click="subInfo">申请提现</el-button>
            </span>
        </el-dialog>

        <el-dialog title="验证" :visible.sync="pwdInfoShow" width="25%" @close="resetInfo" :close-on-click-modal="false">
            <el-form :model="pwdInfo" ref="pwdInfo" label-width="130px" :inline="false" size="small" class="wrap">
                <el-form-item label="密码验证" prop="pwd">
                    <el-input type="password" v-model="pwdInfo.pwd" style="width: 120px;"></el-input>
                    <p class="tips">*如果没有设置密码，请点击'忘记密码?'设置密码</p>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-link type="primary" @click="changePwd">忘记密码?</el-link>
                <el-button type="primary" size="mini" @click="subpwdInfo" style="margin-left: 20px;">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="手机号验证" :visible.sync="verificationShow" width="25%" @close="resetInfo"
            :close-on-click-modal="false">
            <el-form :model="verificationInfo" ref="verificationInfo" label-width="130px" :inline="false" size="small"
                class="wrap">
                <el-form-item label="手机号" prop="phone">
                    <el-input type="tel" v-model="verificationInfo.phone" style="width: 120px;"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                    <el-input v-model="verificationInfo.code" style="width: 120px;" @focus="onFocus"></el-input>
                    <div class="divbtn">
                        <span v-show="show" @click="getCode">获取验证码</span>
                        <span v-show="!show" class="count">{{ count }} s</span>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button size="mini" type="primary" @click="submit" style="margin-left: 20px;">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="修改密码" :visible.sync="changePwdShow" width="25%" @close="resetInfo"
            :close-on-click-modal="false">
            <el-form :model="changPwdInfo" ref="changePwdInfo" label-width="130px" :inline="false" size="small"
                class="wrap">
                <el-form-item label="输入新密码">
                    <el-input v-model="changPwdInfo.pwd" type="password" style="width: 120px;" @blur="onBlur">
                    </el-input>
                </el-form-item>
                <el-form-item label="再次输入新密码">
                    <el-input v-model="changPwdInfo.isPwd" type="password" style="width: 120px;" @blur="onBlur">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button size="mini" type="primary" @click="subChangePwd" style="margin-left: 20px;">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="确认银行卡信息" :visible.sync="bankInfoShow" width="40%" @close="resetInfo"
            :close-on-click-modal="false">
            <el-form :model="bankInfo" ref="bankInfo" label-width="130px" :inline="false" size="small" class="wrap">
                <el-form-item>
                    <p>银行：{{ bankInfo.card_bank.name }}</p>
                </el-form-item>
                <el-form-item>
                    <p>银行卡号：{{ bankInfo.card_num }}</p>
                </el-form-item>
                <el-form-item>
                    <p>开户姓名：{{ bankInfo.card_name }}</p>
                </el-form-item>
                <el-form-item>
                    <p>开户预留手机号：{{ bankInfo.card_phone }}</p>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button size="mini" type="primary" @click="subBank" style="margin-left: 20px;">確定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Withdraw',
        data() {
            return {
                loading: false,
                keyword: '',
                date: '',
                tableData: [],
                page: 1,
                maxpage: 1,
                total: 0,
                info: {
                    money: '',
                    phone: '',
                    member_id: '',
                },
                infoShow: false,
                balance: '',
                balance_available: '',
                balance_unavailable: '',
                estimate: '',
                pwdInfo: {
                    pwd: '',
                },
                pwdInfoShow: false,
                verificationInfo: {
                    phone: '',
                    code: '',
                },
                verificationShow: false,
                show: true,
                count: '',
                timer: null,
                changPwdInfo: {
                    pwd: '',
                    isPwd: '',
                },
                changePwdShow: false,
                bankInfo: {
                    card_bank: {},
                    card_identity_front: "",
                    card_identity_reverse: "",
                    card_name: "",
                    card_num: "",
                    card_phone: "",
                },
                bankInfoShow: false,
            }
        },
        methods: {
            getData() {
                // this.loading = true
                // this.$util.get('agent/wallet_record', {
                // 		type: 1,
                // 		page: this.page
                // 	})
                // 	.then(res => {
                // 		console.log(res)
                // 		this.loading = false
                // 		this.balance = res.balance ? res.balance : '0.00'
                // 		this.balance_available = res.balance_available ? res.balance_available : '0.00'
                // 		this.balance_unavailable = res.balance_unavailable ? res.balance_unavailable : '0.00'
                // 		this.estimate = res.estimate ? res.estimate : '0.00'
                // 	})
                this.getTransTransaction()
                this.getInfo()
            },
            getTransTransaction() {
                // this.$util.get('agent/getTransTransaction', {
                // 		page: this.page,
                // 		type: 3
                // 	})
                // 	.then(res => {
                // 		console.log(res.data)
                // 		this.tableData = res.data
                // 		this.total = res.total
                // 		this.maxpage = res.last_page
                // 	})
            },
            getInfo() {
                // this.$util.get('agent/getAgentInfo')
                // 	.then(res => {
                // 		console.log(res)
                // 		this.info.phone = res[0].mobile
                // 		this.info.member_id = res[0].member_id
                // 		if (res[0].bank_info) {
                // 			this.bankInfo = JSON.parse(res[0].bank_info)
                // 			if (this.bankInfo.card_bank) {
                // 				this.bankInfo.card_bank = JSON.parse(this.bankInfo.card_bank)
                // 			} else {
                // 				this.bankInfo.card_bank = ""
                // 			}
                // 		} else {
                // 			this.bankInfo = null
                // 		}
                // 	})
            },
            pageChange(page) {
                this.tableData = []
                this.page = page
                this.getData()
            },
            toSearch() {
                this.page = 1
                this.maxpage = 1
                this.total = 0
                this.tableData = []
                this.getData()
            },
            refresh() {
                this.getData()
            },
            toWithdraw() {
                if (this.bankInfo) {
                    this.infoShow = true
                } else {
                    alert("您没有绑定银行卡，请先绑定银行卡")
                    this.$router.push('/agent/cardManagement')
                }
            },
            resetInfo() {
                this.info = {
                    money: '',
                    phone: '',
                    member_id: '',
                }
                this.pwdInfo = {
                    pwd: '',
                }
                this.verificationInfo = {
                    phone: '',
                    code: '',
                }
                this.changPwdInfo = {
                    pwd: '',
                    isPwd: '',
                }
                this.bankInfo = {
                    card_bank: {},
                    card_identity_front: "",
                    card_identity_reverse: "",
                    card_name: "",
                    card_num: "",
                    card_phone: "",
                }
                this.infoShow = false
                this.pwdInfoShow = false
                this.verificationShow = false
                this.changePwdShow = false
                this.bankInfoShow = false
                this.getData()
            },
            subInfo() {
                if (this.info.money && this.info.money <= Number(this.balance_available)) {
                    this.pwdInfoShow = true
                } else {
                    this.$message('请输入正确的金额')
                }
            },
            subpwdInfo() {
                this.info = {
                    member_id: this.info.member_id,
                    money: this.info.money,
                    phone: this.info.phone
                }
                // this.$util.get('verify_password', {
                // 		password: this.pwdInfo.pwd,
                // 		member_id: this.info.member_id
                // 	})
                // 	.then(res => {
                // 		console.log(res)
                // 		this.bankInfoShow = true
                // 	})
            },
            changePwd() {
                this.info = {
                    member_id: this.info.member_id,
                    money: this.info.money,
                    phone: this.info.phone
                }
                this.verificationShow = true
                this.verificationInfo.phone = this.info.phone
            },
            onFocus() {
                if (this.verificationInfo.phone == '') {
                    this.$message('请输入手机号')
                }
            },
            getCode() {
                if (this.verificationInfo.phone == '') {
                    this.$message('请输入手机号')
                } else {
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                    this.$util.get('msgSet', {
                        phone: this.verificationInfo.phone,
                    })
                        .then(res => {
                            console.log(res)
                        })
                }
            },
            submit() {
                this.$util.get('phone_verify', {
                    phone: this.verificationInfo.phone,
                    code: this.verificationInfo.code,
                })
                    .then(res => {
                        console.log(res)
                        this.changePwdShow = true
                    })
            },
            onBlur() {
                var reg = /^[0-9]*$/;
                var password = new RegExp(reg);
                if (this.changPwdInfo.pwd != "" || this.changPwdInfo.isPwd != "") {
                    if (password.test(this.changPwdInfo.pwd) == false || password.test(this.changPwdInfo.isPwd) ==
                        false) {
                        this.$message("请输入数字密码！");
                    } else if (this.changPwdInfo.pwd.length < 6 || this.changPwdInfo.isPwd.length < 6) {
                        this.$message("密码不小于6位");
                    } else if (this.changPwdInfo.isPwd != this.changPwdInfo.pwd) {
                        this.$message("密码不正确")
                    }
                } else {
                    this.$message('密码不能为空')
                }
            },
            subChangePwd() {
                this.info = {
                    member_id: this.info.member_id,
                    money: this.info.money,
                    phone: this.info.phone
                }
                // this.$util.get('change_password', {
                // 		new_password: this.changPwdInfo.pwd,
                // 		member_id: this.info.member_id
                // 	})
                // 	.then(res => {
                // 		console.log(res)
                // 		this.$message("修改成功！")
                // 		this.infoShow = true
                // 		this.changePwdShow = false
                // 		this.getData()
                // 	})
            },
            subBank() {
                this.info = {
                    money: this.info.money,
                    phone: this.info.phone,
                    member_id: this.info.member_id
                }
                // this.$util.get('agent/withdraw_apply', {
                // 		money: this.info.money,
                // 		phone: this.info.phone
                // 	})
                // 	.then(res => {
                // 		console.log(res)
                // 		this.$alert('申请已提交')
                // 		this.getData()
                // 		this.bankInfoShow = false
                // })
            }
        },
        activated() {
            this.getData()
        }
    }
</script>

<style scoped>
    .el-table {
        margin-top: 30px;
    }

    .el-date-editor--daterange.el-input__inner {
        width: 265px;
    }

    .el-table /deep/ .cell {
        text-align: center;
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .top {
        margin-top: 30px;
    }

    .wallet-index,
    .withdrawal {
        width: 285px;
        border-right: 1px solid #888888;
        text-align: center;
        height: 100px;
    }

    .wallet-index p:first-child {
        font-size: 22px;
        font-weight: 500;
        line-height: 20px;
        color: #111111;
        margin-top: 20px;
    }

    .wallet-index p:last-child {
        font-size: 26px;
        font-weight: bold;
        line-height: 30px;
        color: #F10019;
        margin-top: 10px;
    }

    .withdrawal {
        border: none;
        line-height: 120px;
        height: 120px;
    }

    .wrap /deep/ .el-form-item__content {
        margin-bottom: 20px;
    }

    .tips {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 17px;
        color: #F10019;
    }

    .divbtn {
        cursor: pointer;
        margin-top: 10px;
        width: 100px;
        height: 30px;
        background: #409EFF;
        text-align: center;
        color: #FFFFFF;
        line-height: 30px;
    }

    .withdrawbtn {
        background: #F10019;
        margin: auto;
    }

    .info,
    .success,
    .error {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #888888;
    }

    .success {
        color: #0CC428;
    }

    .error {
        color: #F10019;
    }
</style>